import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import screens from "../routes";
import RegisterRoute from "./RegisterRoute";

function Routing() {
  return (
    <BrowserRouter basename="/">
      <Routes>
        {screens.map((screen, index) => (
          <Route
            key={`Route::${index}::${screen.pathname}`}
            path={screen.pathname}
            element={<RegisterRoute {...screen} />}
          />
        ))}
      </Routes>
    </BrowserRouter>
  );
}

export default Routing;
